__turbopack_context__.v({
  "className": "vazirmatn_ce3aff62-module__e7Z88W__className",
  "variable": "vazirmatn_ce3aff62-module__e7Z88W__variable",
});
